import projection from '../generated/pwd5m4f1.json';
import { AcceptanceManifest } from '../types';
export const pwd5m4f1AcceptanceManifest = projection as AcceptanceManifest;
